import React, {useRef, useMemo} from "react";
import useToggle from "../../shared/functions/useToggle";
import {DateTime} from 'luxon'

import {flattenDeep} from 'lodash'

import {Chip, Popover, Stack, Typography, Box, IconButton} from "@mui/material";
import AntDataGrid from "../../shared/components/AntDataGrid";
import {Close} from "@mui/icons-material";

const THEAD = [
    {title: 'Ref', dataIndex: 'ref'},
    {title: 'State', dataIndex: 'state'},
    {title: 'Quantity', dataIndex: 'quantity'},
]

const Table = ({rows = [], title, color = 'default'}) => {
    //console.log(rows)
    const quantities = rows?.map(one => one?.quantity);
    let total = 0;
    quantities.forEach(t => total += t)

    return (
        <Stack direction={'column'} spacing={1} sx={{mb: 3}}>
            <Stack direction={'row'} justifyContent={'space-between'} sx={{borderRadius: 10, bgcolor: color, px: 2}}>
                <Typography variant={'subtitle1'} sx={{fontWeight: 'bold', color: 'white'}}>
                    {title}
                </Typography>
                <Typography variant={'body1'} sx={{color: 'white'}}>
                    {total}
                </Typography>
            </Stack>

            <AntDataGrid
                columns={THEAD}
                data={rows}
            />
        </Stack>
    )
}

const lastThreeMonth = (SalesSheet) => {
    const month = ["January","February","March","April","May","June","July","August","September","October","November","December"];

    const d = new Date();
    let firsrMonthname = month[d.getMonth()];
    let secondMonthname = month[d.getMonth()+1];
    let thirdMonthname = month[d.getMonth()+2];
    
    return [firsrMonthname, secondMonthname, thirdMonthname]
}

export default function InventoryOrdered({pos = [], shipping = [], totalQuantity = 0, SalesSheet, ...rest}) {

    const ref = useRef()
    const {open, handleOpen, handleClose} = useToggle()

    var last = lastThreeMonth(SalesSheet) 


    const quantity = ((rest?.Stores?.Cassablanca?.Quantity || rest?.Stock?.Cassablanca || 0) + (rest?.Stores?.Dekon?.Quantity || rest?.Stock?.Dekon || 0)) || 0

    const total = useMemo(() => {
        const list = flattenDeep([...pos.map(one => one?.quantity || 0), ...shipping.map(one => one?.quantity || 0)])
        let result = 0

        list.forEach(number => {
            result += number
        })

        return result + quantity

    }, [pos, shipping, quantity])

    


    return (
        <Box ref={ref}>
            <Chip
                label={0}
                onClick={handleOpen}
            />

            <Popover open={open} anchorEl={ref.current} onClose={handleClose}>
                <Stack direction={'column'} sx={{p: 2, minWidth: 400}}>
                    <Stack direction={'row'} justifyContent={'space-between'} sx={{mb: 5}}>
                        <Typography variant={'h6'}>
                            Detail
                        </Typography>
                        <IconButton onClick={handleClose}>
                            <Close/>
                        </IconButton>
                    </Stack>

                </Stack>
            </Popover>
        </Box>
    )
}